//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.Subdivision.js";
import "../no/TransientObject.js";
import "../no/SubdivisionMeshEdgeProxy.js";
import "../no/SubdivisionMeshFaceProxy.js";
import "../no/SubdivisionMeshVertexProxy.js";
let d=[[],[[[],"Dispose",{},0,0],[["numNewFaces","newFaces","numModifiedFaces","modifiedFaces","numDeletedFaceIds","deletedFaceIds"],"GetFaces",{},0,0],[["numNewEdges","newEdges","numModifiedEdges","modifiedEdges","numDeletedEdgeIds","deletedEdgeIds"],"GetEdges",{},0,0],[["numNewVertices","newVertices","numModifiedVertices","modifiedVertices","numDeletedVertexIds","deletedVertexIds"],"GetVertices",{},0,0],[["numDeletedBodyIds","deletedBodyIds"],"GetDeletedBodies",{},0,0]],[]];
SPLM.Features.Subdivision.MeshBodyTrackingData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.Subdivision.MeshBodyTrackingData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;